// SHA-973 P4c (E8): "Not now" on the upcoming-cellular pop-up snoozes it until a week
// before the included service ends (the T-7 notice), per end day. Browser storage
// only: it can be unavailable, and then the pop-up simply shows again.
const KEY_PREFIX = 'cellularUpcoming.notNow.'

const DAY_MS = 86_400_000

/** When the pop-up may show again: 7 days before `endsOn` (YYYY-MM-DD, UTC midnight). */
export const snoozeEndsAt = (endsOn: string): number => Date.parse(`${endsOn}T00:00:00Z`) - 7 * DAY_MS

export const isUpcomingSnoozed = (endsOn: string | null | undefined, now: number = Date.now()): boolean => {
  if (!endsOn) return false
  try {
    const until = Number(window.localStorage.getItem(`${KEY_PREFIX}${endsOn}`))
    return Number.isFinite(until) && until > now
  } catch (error) {
    return false
  }
}

export const snoozeUpcoming = (endsOn: string): void => {
  try {
    window.localStorage.setItem(`${KEY_PREFIX}${endsOn}`, String(snoozeEndsAt(endsOn)))
  } catch (error) {
    // Storage blocked: the pop-up closes for now and shows again next time.
  }
}
